import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { getProjectInfo } from "../../projects/api/project";
import { useAuth } from "./AuthContext";
import { toast } from "../components/Toast";

const ProjectContext = createContext();

export const ProjectProvider = ({ children }) => {
  const [project, setProject] = useState(null);
  const [currentUserRole, setCurrentUserRole] = useState(null);
  const [currentProjectUser, setCurrentProjectUser] = useState(null);
  const { id: currentUserId } = useAuth();

  // Fetch project info on mount
  useEffect(() => {
    const fetchProjectInfo = async () => {
      try {
        const data = await getProjectInfo();
        setProject(data);
      } catch (error) {
        toast.error(error.message || "Failed to fetch project info");
      }
    };

    if (currentUserId) {
      fetchProjectInfo();
    }
  }, [currentUserId]);

  // Derive current user role whenever project or user changes
  useEffect(() => {
    if (project && project.users && currentUserId) {
      const currentUserInProject = project.users.find(
        (user) => user.user_details.id === parseInt(currentUserId),
      );
      setCurrentUserRole(currentUserInProject?.role || null);
      setCurrentProjectUser(currentUserInProject || null);
    }
  }, [project, currentUserId]);

  const refreshProject = useCallback(async () => {
    try {
      const data = await getProjectInfo();
      setProject(data);
    } catch (error) {
      toast.error(error.message || "Failed to fetch project info");
    }
  }, []);

  return (
    <ProjectContext.Provider
      value={{
        project,
        setProject,
        refreshProject,
        currentUserRole,
        currentProjectUser,
      }}
    >
      {children}
    </ProjectContext.Provider>
  );
};

export const useProject = () => useContext(ProjectContext);
